import { message } from 'antd'
import { push } from 'connected-react-router'
import { store } from './configureStore'

message.config({ duration: 4, maxCount: 1 })

export const showErrorMessage = error => {
  console.error({ error })

  if (error.response) {
    if (error.response.status === 401) {
      message.error('Ошибка доступа', 1).then(() => {
        store.dispatch(push('/login'))
      })
    }

    if (error.response.status === 400) {
      message.error('Ошибка выполнения запроса')
    }

    if (error.response.status === 403) {
      const state = store.getState();

      // условие для того, чтобы не показывать ошибку доступа неверифицированному пользователю
      if (state.user && state.user.state !== undefined && state.user.state !== "unverified") {
        message.error('Ошибка доступа. Недостаточно прав для выполнения операции')
      }
    }

    if (error.response.status === 500) {
      if (error.response.data.code === 31) {
        message.error('Переводы между партнёрами из РФ и зарубежных стран приостановлены')
      } else {
        message.error('При выполнении запроса произошла внутренняя ошибка сервера')
      }
    }
  }

  if (error.message === 'Network Error') {
    message.error('Ошибка соединения. Проверьте подключение к интернету')
  }

  if (error.message === RESERVED_ERROR_CODES.INVALID_COUNTRY) {
    message.error("К сожалению Вывод денежных средств на банковские карты РФ невозможен.")
  }
}

export const RESERVED_ERROR_CODES = {
  INVALID_COUNTRY: 'invalid_country'
}
